import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fdbc2100"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sole-trader-data-wrapper md:!tw-h-full tw-border-t-solid-custom" }
const _hoisted_2 = { class: "form__wrapper !tw-w-full !tw-max-w-[unset] md:!tw-m-0" }
const _hoisted_3 = { class: "modal_input_wrapper tw-flex tw-flex-col tw-gap-4" }
const _hoisted_4 = { class: "modal_input !tw-m-0 tw-flex tw-flex-col tw-gap-2 tw-items-start" }
const _hoisted_5 = {
  key: 0,
  class: "tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-3 tw-p-2 tw-overflow-y-auto"
}
const _hoisted_6 = { class: "selection-card tw-w-full tw-bg-[#FFF] tw-rounded-lg tw-px-4 tw-box-border tw-flex tw-items-center tw-gap-2" }
const _hoisted_7 = { class: "kyp-score tw-grid tw-w-full tw-border-t-solid-custom tw-p-4 tw-box-border tw-gap-4" }
const _hoisted_8 = { class: "kyp-score tw-grid tw-w-full tw-border-t-solid-custom tw-p-4 tw-box-border tw-gap-4" }
const _hoisted_9 = { class: "modal_input !tw-m-0 tw-flex tw-flex-col tw-gap-2 tw-items-start" }
const _hoisted_10 = { class: "modal_input !tw-m-0 tw-flex tw-flex-col tw-gap-2 tw-items-start" }
const _hoisted_11 = {
  key: 0,
  class: "modal_input !tw-m-0 tw-gap-0 tw-flex tw-flex-col w-full"
}
const _hoisted_12 = { class: "tw-mt-2 tw-mb-4 tw-w-full tw-h-auto tw-flex tw-flex-col tw-gap-4 tw-p-3 tw-box-border tw-border-[1px] tw-border-[#DFDFDF] tw-border-solid tw-rounded-[8px] tw-bg-[#F8FBFD]" }
const _hoisted_13 = { class: "upload__section md:!tw-h-[100px]" }
const _hoisted_14 = { class: "uploade-wrapper custom-file-upload !tw-h-[97px] md:!tw-h-full !tw-w-full !tw-mt-4 !tw-rounded-lg tw-border-[rgba(0,0,0,0.4)] tw-border-[1px] tw-border-dashed !tw-mb-4" }
const _hoisted_15 = { class: "attachment-list !tw-mt-0" }
const _hoisted_16 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_17 = {
  key: 0,
  class: "w-full sm:w-80"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "  Uploading file...", -1))
const _hoisted_19 = {
  key: 1,
  class: "add-more-data !tw-mt-0"
}
const _hoisted_20 = { class: "tw-w-full tw-flex tw-gap-3 tw-items-center tw-justify-end tw-pt-4 tw-border-t-dashed-custom" }

import { computed, ref } from "vue";
import ItemListCard from "@/core/components/ItemListCard.vue";
import WizardModal from "@/core/components/modals/WizardModal.vue";
import ServiceIconWrapper from "@/core/components/common/ServiceIconWrapper.vue";
import { useStore } from "vuex";
import { USER_STORE } from "@/store/modules/user";
import { CERTIFICATE_STORE } from "@/store/modules/certificates";
import { onBeforeMount } from "vue";
import { watch } from "vue";
import { onMounted, onBeforeUnmount } from "vue";
import { WORKSTATION } from "@/store/modules/workstation";
import Text from "@/core/components/ui/general/Text.vue";
import Button from "@/core/components/ui/general/Button.vue";
import InputField from "@/core/components/common/InputField.vue";
import CollapsibleWidgetSlot from "@/core/components/slots/CollapsibleWidgetSlot.vue";
import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import PdfIcon from "@/core/components/icons/PdfIcon.vue";
import ImageIcon from "@/core/components/icons/ImageIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddCertificateModal',
  props: {
  userCertificateData: { type: Object, default: null },
},
  emits: ["onClickCloseTab", "clearUserCertificateData"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const props = __props;
const isFileInputDisabled = ref(false);
const isShowQualificationForm = ref(true);
const isQualificationSubmitting = ref(false);
const store = useStore();
const uploadProgress = ref(0);
const modelDetails = ref({
  id: 2,
  tab: "Certifications",
  name: "certifications",
  header: "Certifications",
  title: "Do you have any certifications?",
  description: `Please enter your qualification details.`,
});
const isFileUploading = ref(false);
const attachmentError = ref("");
const imageData = ref("");
const user = computed(() => store.getters[`${USER_STORE}/user`]);
const qualificationData = ref({
  certificateId: null,
  registrationNumber: null,
  url: null,
  attachments: [],
}) as any;
const certificationFormRef = ref(null) as any;
const hasInteracted = ref(false);
const validation = ref({
  certificateId: [
    (v: any) =>
      hasInteracted.value ? !!v || "Select one certification" : true,
  ],
  typeText: [
    (v: string) => !!v || "Provide a certification type",
    (v: string) => isNaN(Number(v)) || "Must be a character",
  ],
  url: [
    (v: any) =>
      !v ||
      /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i.test(v) ||
      "Please provide a valid certificate URL.",
  ],
  attachments: [(v: any[]) => v.length > 0 || "Attachment is required"],
});

const isFormValid = ref(false);
const customType = ref("");

const isShowSelectCertificates = ref(false);
const certificateName = ref("");

// not applicabble or don't have any = 10
// other = 9

const certificateDummyDataElectrical = ref([
  {
    name: "18th Edition (Issued within the last 5 years)",
    id: 18,
  },
  {
    name: "NVQ Level 3 Electrical Installation & Maintenance",
    id: 19,
  },
  {
    name: "ECS Gold Card -  Electrical Installation",
    id: 20,
  },
  {
    name: "Part 1 & 2 Electrical Installation (Issued before 1994)",
    id: 21,
  },
]);

const certificateDummyDataPlumbing = ref([
  {
    name: "Gas Safe (CENWAT)",
    id: 11,
  },
  {
    name: "OFTEC (OFT10-105E or OFT15-108W), MCS (Heat Pump or Solar Thermal Hot Water) or HETAS (H004) registration",
    id: 12,
  },
  {
    name: "N/SVQ Level 2/3 in Plumbing or equivalent earlier certification that provides evidence of competence",
    id: 13,
  },
  {
    name: "N/SVQ Level 2/3 in Heating and Ventilating (Domestic Installation) or equivalent earlier certification that provides evidence of competence",
    id: 14,
  },
  {
    name: "N/SVQ Level 2/3 in Heating and Ventilating (Industrial and Commercial Installation) or equivalent earlier certification that provides evidence of competence",
    id: 15,
  },
  {
    name: "N/SVQ Level 2/3 in Oil-Fired Technical Services or equivalent earlier certification that provides evidence of competence",
    id: 16,
  },
  {
    name: "N/SVQ Level 2/3 in Gas Installation and Maintenance or equivalent earlier certification that provides evidence of competence",
    id: 17,
  },
  {
    name: "NICEIC",
    id: 2,
  },
  {
    name: "Trust Mark",
    id: 3,
  },
  {
    name: "Federation of Master Builders",
    id: 4,
  },
  {
    name: "ECA",
    id: 5,
  },
  {
    name: "NAPIT",
    id: 6,
  },
  {
    name: "FENSA",
    id: 7,
  },
  {
    name: "NFRC",
    id: 8,
  },
]);

const onToggleShowSelectCertificate = () => {
  // if searching always show the selected dates ui
  if (!qualificationData.value.certificateId && certificateName.value !== "") {
    isShowSelectCertificates.value = true;
    return;
  }
  // if navigating back to selectDates from add spots screen
  // if (!isShowSelectCertificates.value && qualificationData.value) {
  //   const newSelectedDates = [];
  //   // Iterate through calendarAttributes
  //   calendarAttributes.value.forEach((item) => {
  //     // Check if the selectedDates contains an item with the same ID as in calendarAttributes
  //     const isSelected = selectedDates.value.find(
  //       (selectedItem) => selectedItem.id === item.id
  //     );

  //     // If it's selected, pre-check the checkbox by pushing it to newSelectedDates
  //     if (isSelected) {
  //       newSelectedDates.push(item);
  //     }
  //   });
  //   // set the newSelectedDates to selectedDates
  //   selectedDates.value = newSelectedDates;
  // }
  isShowSelectCertificates.value = !isShowSelectCertificates.value;

  // make sure add spots section is close if select dates is open
  // if (isShowSelectCertificates.value) {
  //   isShowAddSpots.value = false;
  // }
};

const onClickBackButton = () => {
  return emit("onClickCloseTab");
};
const userCertificates = computed(
  () => store.getters[`${USER_STORE}/userCertificates`]
);

const isSaveButtonDisable = computed(
  () =>
    !isFormValid.value ||
    (!(
      qualificationData.value.attachments.length &&
      qualificationData.value.certificateId
    ) &&
      qualificationData.value.certificateId !== 10)
);

const onClickAddQualification = async () => {
  try {
    const isFormValid = await certificationFormRef.value.validate();
    isQualificationSubmitting.value = true;
    if (
      !qualificationData.value.url &&
      !qualificationData.value.attachments.length &&
      qualificationData.value.certificateId !== 10
    ) {
      attachmentError.value =
        "Add credential URL or upload evidence to continue";
      return;
    }
    if (!isFormValid.valid) return;
    let certificateData;
    interface Metadata {
      url: string;
      registrationNumber: string;
      name?: string; // Optional property
    }

    if (isEditCertificate.value) {
      certificateData = {
        certificateId: qualificationData.value.certificateId,
        metadata: {
          url: qualificationData.value.url,
          registrationNumber: qualificationData.value.registrationNumber,
        } as Metadata,
        attachment: qualificationData.value.attachments[0],
      };

      if (qualificationData.value.certificateId === getOthersId.value) {
        certificateData.metadata.name = customType.value || "";
      }
      await store.dispatch(`${USER_STORE}/updateUserCertificate`, {
        userId: user.value?.id,
        id: userCertificateModalData.value?.id,
        certificate: certificateData,
      });
    } else {
      certificateData = {
        userId: user.value.id,
        certificateId: qualificationData.value.certificateId,
        metadata: {
          url: qualificationData.value.url,
          registrationNumber: qualificationData.value.registrationNumber,
        } as Metadata,
        attachments: qualificationData.value.attachments,
      };

      if (qualificationData.value.certificateId === getOthersId.value) {
        certificateData.metadata.name = customType.value || "";
      }
      await store.dispatch(`${USER_STORE}/addNewCertificate`, certificateData);
    }
    isShowQualificationForm.value = false;
  } catch (error) {
    console.log();
  } finally {
    isQualificationSubmitting.value = false;
    await store.dispatch(`${USER_STORE}/setUserCertificates`, user.value?.id);
    await store.dispatch(`${WORKSTATION}/setActiveUserWorkstation`);
    onClickQualificationContinue();
  }
};

const deleteCertificate = async (certificateId: number) => {
  try {
    await store.dispatch(`${USER_STORE}/removeUserCertificates`, {
      userId: user?.value?.id,
      userCertificateId: certificateId,
    });
    if (!userCertificates.value.length) {
      isShowQualificationForm.value = true;
    }
  } catch (error) {
    console.log();
  }
};
const onClickCancelButton = () => {
  isShowQualificationForm.value = false;
};

const isEditCertificate = computed(() => {
  return userCertificateModalData.value ? true : false;
});
const editCertificate = (certificate: any) => {
  qualificationData.value.certificateId = certificate?.certificate?.id;
  qualificationData.value.registrationNumber =
    certificate?.metadata?.registrationNumber;
  qualificationData.value.url = certificate?.metadata?.url;
  qualificationData.value.attachments = certificate?.attachment;
  isShowQualificationForm.value = true;
  userCertificateModalData.value = certificate;
};

const onClickAddAnotherQualification = () => {
  qualificationData.value = {
    certificateId: null,
    registrationNumber: null,
    url: null,
    attachments: [],
  };
  userCertificateModalData.value = false;
  isShowQualificationForm.value = true;
};
const onClickQualificationContinue = () => {
  return emit("onClickCloseTab");
};

const certificateList = computed(
  () => store.getters[`${CERTIFICATE_STORE}/certificates`]
);

const getOthersId = computed(() => {
  if (!certificateList.value) {
    return null;
  }
  const foundItem = certificateList.value.find(
    (item: any) => item.template === "Other"
  );
  return foundItem ? foundItem.id : null;
});

const onFileChange = async (event: any) => {
  try {
    isFileUploading.value = true;
    attachmentError.value = "";
    uploadProgress.value = 0;
    const fileInput = event.target;
    if (fileInput.files && fileInput.files.length > 0) {
      const file = fileInput.files[0];

      imageData.value = file;
      const formData = new FormData();
      formData.append("file", imageData.value);

      const progressInterval = setInterval(() => {
        if (uploadProgress.value < 100) {
          uploadProgress.value += 10;
        }
      }, 120);

      const uploadImg = await store.dispatch(
        `${USER_STORE}/uploadProfileImage`,
        formData
      );
      if (uploadImg) {
        clearInterval(progressInterval);
        uploadProgress.value = 100;
      }

      qualificationData.value.attachments = [uploadImg];
    }
  } catch (error) {
    console.error("Error uploading file:", error);
    attachmentError.value = "Error uploading file.";
  } finally {
    isFileUploading.value = false;
  }
};

const getCertificateNameById = async (id: number) => {
  // Combine both arrays for a unified search
  const allCertificates = [
    ...certificateDummyDataElectrical.value,
    ...certificateDummyDataPlumbing.value,
  ];

  // Find the object with the matching id
  const certificate = allCertificates.find((cert) => cert.id === id);

  // Return the name if found, otherwise return a default message
  return certificate ? certificate.name : "Certificate not found";
};

watch(
  () => qualificationData.value.certificateId,
  async () => {
    if (qualificationData.value.certificateId) {
      if (qualificationData.value.certificateId === 10) {
        certificateName.value = "I Do Not Have Any Qualifications";
        return;
      }
      certificateName.value = await getCertificateNameById(
        qualificationData.value.certificateId
      );
      console.log(certificateName.value, "certificateName");
    } else {
      certificateName.value = "";
    }
  },
  { deep: true }
);

watch(
  () => qualificationData.value.url,
  () => {
    attachmentError.value = "";
  }
);

watch(
  () => certificateName.value,
  (value) => {
    if (value == "I Do Not Have Any Qualifications") {
      isFileInputDisabled.value = true;
    } else {
      isFileInputDisabled.value = false;
    }
  },
  { deep: true, immediate: true }
);
onBeforeMount(async () => {
  await store.dispatch(`${CERTIFICATE_STORE}/getAllCertificates`);
  if (userCertificateModalData.value) {
    const userCertifiCateId = certificateList.value?.find(
      (certificate: any) =>
        certificate.name === userCertificateModalData.value?.certificate?.name
    );
    qualificationData.value.certificateId = userCertifiCateId?.id;
    qualificationData.value.url = userCertificateModalData.value?.metadata?.url;
    qualificationData.value.registrationNumber =
      userCertificateModalData.value?.metadata?.registrationNumber;
    qualificationData.value.attachments =
      userCertificateModalData.value?.attachment;
  }
});
const userCertificateModalData = ref(null) as any;
onMounted(() => {
  userCertificateModalData.value = props.userCertificateData;
  // if (userCertificates.value && userCertificates.value.length) {
  //   isShowQualificationForm.value = false;
  //   if (
  //     props.userCertificateData === undefined ||
  //     props.userCertificateData === null
  //   ) {
  //     isShowQualificationForm.value = false;
  //   } else {
  //     isShowQualificationForm.value = true;
  //   }
  // } else {
  //   isShowQualificationForm.value = true;
  // }
  console.log(certificateList.value, "certificateList");
});

const clearAttachments = () => {
  qualificationData.value.attachments = [];
};
onBeforeUnmount(() => {
  emit("clearUserCertificateData");
});

return (_ctx: any,_cache: any) => {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(GeneralDialog, {
    onOnClose: onClickBackButton,
    maxWidth: "100%",
    headerTitle: "Add Education & Certifications",
    headerDescription: "Please enter your qualification details; note that proof will be required before engaging in any projects on iKnowa.",
    width: "570px",
    isTitleStrong: false,
    paddingLarge: false
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_form, {
            onSubmit: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"])),
            rules: validation.value,
            ref_key: "certificationFormRef",
            ref: certificationFormRef,
            class: "md:!tw-h-full",
            modelValue: isFormValid.value,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((isFormValid).value = $event))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(Text, {
                    variant: "span",
                    textWeight: "400"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Title")
                    ]),
                    _: 1
                  }),
                  _createVNode(InputField, {
                    class: "!tw-w-full custom-selector",
                    modelValue: certificateName.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((certificateName).value = $event)),
                    rules: validation.value.certificateId,
                    "append-inner-icon": 
                    !isShowSelectCertificates.value
                      ? 'mdi-chevron-down'
                      : 'mdi-chevron-up'
                  ,
                    onClick: onToggleShowSelectCertificate,
                    placeholder: "E.g, Plumbing & Heating"
                  }, null, 8, ["modelValue", "rules", "append-inner-icon"]),
                  (isShowSelectCertificates.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_v_checkbox, {
                            modelValue: qualificationData.value.certificateId,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((qualificationData.value.certificateId) = $event)),
                            color: "primary",
                            label: "I Do Not Have Any Qualifications",
                            value: 10,
                            "hide-details": "",
                            onChange: _cache[2] || (_cache[2] = ($event: any) => (hasInteracted.value = true))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createVNode(CollapsibleWidgetSlot, {
                          title: "Electrical",
                          isExpand: true
                        }, {
                          content: _withCtx(() => [
                            _createElementVNode("section", _hoisted_7, [
                              _createVNode(_component_v_radio_group, {
                                modelValue: qualificationData.value.certificateId,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((qualificationData.value.certificateId) = $event)),
                                column: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(certificateDummyDataElectrical.value, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_v_radio, {
                                      key: index,
                                      color: "primary",
                                      label: item.name,
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(CollapsibleWidgetSlot, {
                          title: "Plumbing & Heating",
                          isExpand: false
                        }, {
                          content: _withCtx(() => [
                            _createElementVNode("section", _hoisted_8, [
                              _createVNode(_component_v_radio_group, {
                                modelValue: qualificationData.value.certificateId,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((qualificationData.value.certificateId) = $event)),
                                column: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(certificateDummyDataPlumbing.value, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_v_radio, {
                                      key: index,
                                      color: "primary",
                                      label: item.name,
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ])
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (qualificationData.value.certificateId === getOthersId.value)
                    ? (_openBlock(), _createBlock(InputField, {
                        key: 1,
                        rules: validation.value.typeText,
                        class: "!tw-w-full",
                        modelValue: customType.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((customType).value = $event)),
                        placeholder: "E.g. Public liability"
                      }, null, 8, ["rules", "modelValue"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(Text, {
                    variant: "span",
                    textWeight: "400"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Membership number "),
                      _createVNode(Text, {
                        variant: "p",
                        textWeight: "600",
                        textColor: "rgba(12, 15, 74, 0.5)"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("(optional)")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(InputField, {
                    class: "!tw-w-full",
                    modelValue: qualificationData.value.registrationNumber,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((qualificationData.value.registrationNumber) = $event)),
                    placeholder: "eg. 12345678"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(Text, {
                    variant: "span",
                    textWeight: "400"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("URL "),
                      _createVNode(Text, {
                        variant: "p",
                        textWeight: "600",
                        textColor: "rgba(12, 15, 74, 0.5)"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("(optional)")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(InputField, {
                    type: "url",
                    class: "!tw-w-full",
                    rules: validation.value.url,
                    modelValue: qualificationData.value.url,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((qualificationData.value.url) = $event)),
                    placeholder: "https://exampleurl.com/gas-safe-certificate.pdf"
                  }, null, 8, ["rules", "modelValue"])
                ]),
                (!isFileInputDisabled.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(Text, {
                        variant: "span",
                        textWeight: "400"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Evidence*")
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_v_file_input, {
                              class: _normalizeClass(["upload_file !tw-mb-0 !tw-bg-white", {
                          'added-img':
                            qualificationData.value.attachments &&
                            qualificationData.value.attachments?.length,
                        }]),
                              label: "Upload images & files, or Browse",
                              variant: "solo-filled",
                              modelValue: qualificationData.value.attachments,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((qualificationData.value.attachments) = $event)),
                              rules: validation.value.attachments,
                              onChange: onFileChange,
                              "prepend-icon": "mdi-file-image-box"
                            }, null, 8, ["modelValue", "rules", "class"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qualificationData.value.attachments, (file, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "attachment-item !tw-bg-none !tw-p-0 !tw-border-none"
                            }, [
                              _createElementVNode("div", _hoisted_16, [
                                (file.mime === 'application/pdf')
                                  ? (_openBlock(), _createBlock(PdfIcon, {
                                      key: 0,
                                      class: "!tw-w-[14px] !tw-h-[12px] !tw-min-w-[14px]"
                                    }))
                                  : (_openBlock(), _createBlock(ImageIcon, {
                                      key: 1,
                                      class: "!tw-w-[14px] !tw-h-[12px] !tw-min-w-[14px]"
                                    })),
                                _createVNode(Text, {
                                  variant: "p",
                                  textWeight: "400"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(file.originalName), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _createVNode(_component_v_icon, {
                                class: "cursor-pointer !tw-text-[16px]",
                                icon: "mdi-close",
                                onClick: clearAttachments
                              })
                            ]))
                          }), 128))
                        ])
                      ]),
                      (isFileUploading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createVNode(_component_v_progress_linear, {
                              "model-value": uploadProgress.value,
                              height: 10,
                              width: 5,
                              striped: "",
                              rounded: "",
                              color: "#0C0F4A"
                            }, null, 8, ["model-value"]),
                            _createTextVNode(" " + _toDisplayString(uploadProgress.value) + " %", 1),
                            _hoisted_18
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (userCertificates.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createVNode(Text, {
                        variant: "h6",
                        textWeight: "600",
                        textColor: "rgba(12, 15, 74, 0.4)",
                        whiteSpace: "nowrap"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Nothing more to add? "),
                          _createVNode(Text, {
                            class: "!tw-cursor-pointer",
                            variant: "h6",
                            textWeight: "600",
                            textColor: "#3366FF",
                            whiteSpace: "nowrap",
                            onClick: onClickQualificationContinue
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Cancel"),
                              _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["rules", "modelValue"])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_20, [
        _createVNode(Button, {
          variant: "secondary",
          label: "Cancel",
          isCapitalize: true,
          onClick: onClickBackButton,
          disabled: isQualificationSubmitting.value,
          class: "!tw-w-auto"
        }, null, 8, ["disabled"]),
        _createVNode(Button, {
          variant: "accent",
          label: 
            isEditCertificate.value ? 'update qualification' : 'add qualification'
          ,
          isCapitalize: true,
          loading: isQualificationSubmitting.value,
          onClick: onClickAddQualification,
          disabled: isSaveButtonDisable.value,
          class: "!tw-w-auto"
        }, null, 8, ["label", "loading", "disabled"])
      ])
    ]),
    _: 1
  }))
}
}

})